/** Cognito challenges where the user enters a one-time code during login. */
export const MFA_VERIFICATION_CHALLENGES = [
  'SMS_MFA',
  'SOFTWARE_TOKEN_MFA',
] as const;

export type MfaVerificationChallenge =
  (typeof MFA_VERIFICATION_CHALLENGES)[number];

export type LoginStep = 'login' | 'challenge';

export interface LoginChallenge {
  challenge_name: string;
  challenge_parameters?: Record<string, string>;
}

export interface LoginResponseBody {
  error: string | null;
  challenge: LoginChallenge | null;
  success: boolean;
  email_verification_required?: boolean;
}

export interface LockoutState {
  message: string;
  lockedUntil: Date;
}

export interface LockoutPayload {
  error: string;
  locked_until?: string;
  retry_after_seconds?: number;
}
